const StoresEn = {
  stores: 'Stores'
};

export default StoresEn;
